import React from "react";
import styled from "styled-components";
import { CommonText } from "styledComponents/common";



import decreaseIcon from "../../../assets/img/icons/decrease.svg";
import increaseIcon from "../../../assets/img/icons/increase.svg";
import { SmallInfoCardSkeletonAmount, SmallInfoCardSkeletonDelta, SmallInfoCardSkeletonIcon, SmallInfoCardSkeletonSubText, SmallInfoCardSkeletonTitle } from "../../DashBoardNew/dashBoardNewStyles";


const Card = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  gap: 12px;
  width: 100%;
  max-width: 420px;
  background: #ffffff;
  border: 1px solid #d3e0fc;
  border-radius: 8px;
  box-shadow: none;
  transition: box-shadow 120ms ease;
  /* &:hover {
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    border-color: #c0d0ce;
  } */

  @media (max-width: 768px) {
    padding: 10px 12px;
    gap: 10px;
    max-width: 100%;
  }

  @media (max-width: 420px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 10px;
  }
`;

const TitleText = styled.p`
  font-family: 'Mona Sans', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  color: #353A46;
  margin: 0;
`;

const ContentLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;

const ContentRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  gap: 5px;
  min-width: 0;
  margin-top:25px
`;

const BodyColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

const AmountContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

const AmountText = styled.div`
  height: 24px;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #000E2A;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const DeltaContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding: 0px;
  gap: 4px;
  min-width: 72px;
  background: red;

  @media (max-width: 420px) {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
`;

const IconWithText = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 4px;
`;

const IconImg = styled.img`
  width: 10px;
  height: 10px;
  display: block;
`;

const DeltaText = styled.span`
  font-family: 'Mona Sans', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 17px;
  color: ${({ deltaType }) => (deltaType === "increase" ? "#27AE60" : "#FF5722")};
`;

const SubText = styled.span`
  font-family: 'Mona Sans', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  color: #7B8281;
`;

const SmallInfoCard = ({
  isLoading,
  iconSrc = null,
  title,
  amount,
  delta,
  deltaType, // 'increase' | 'decrease'
  subText
}) => {

  const showDelta = delta !== undefined && delta !== null;
  const icon = deltaType === "increase" ? increaseIcon : decreaseIcon;

  // Render skeleton loading state
  if (isLoading) {
    return (
      <Card>
        <ContentLeft>
          {/* Show skeleton icon if iconSrc is provided */}
          {iconSrc ? <SmallInfoCardSkeletonIcon /> : null}

          <BodyColumn>
            <SmallInfoCardSkeletonTitle />
            <SmallInfoCardSkeletonAmount />
          </BodyColumn>
        </ContentLeft>

        <ContentRight>
          {showDelta ? <SmallInfoCardSkeletonDelta /> : null}
          <SmallInfoCardSkeletonSubText />
        </ContentRight>
      </Card>
    );
  }

  return (
    <Card>
      <ContentLeft>
        {/* optional icon */}
        {iconSrc ? (
          <div style={{ flex: "0 0 auto" }}>
            <img src={iconSrc} alt="icon" style={{ width: 36, height: 36 }} />
          </div>
        ) : null}

        <BodyColumn>
          <TitleText>{title}</TitleText>
          <AmountText>{amount}</AmountText>
        </BodyColumn>
      </ContentLeft>

      <ContentRight >
        {showDelta ? (
          <IconWithText>
            <IconImg src={icon} alt={deltaType} />
            <DeltaText deltaType={deltaType}>{delta}</DeltaText>
          </IconWithText>
        ) : null}
        <SubText>{subText}</SubText>
      </ContentRight>
    </Card>
  );
};

export default SmallInfoCard;